export const getFeatures = (finalFeatures, annotationId) =>
  finalFeatures.reduce((acc, item) => {
    if (item.value && item.public && item.annotation_id === annotationId) {
      return [
        ...acc,
        {
          operator: 'equals',
          equals_values: [item.value],
          feature: item.feature_id,
        },
      ];
    }
    return acc;
  }, []);

export const getConstraintSet = (annotations, finalFeatures, len) => {
  const conditions = [];
  const publicAnnotations = annotations.filter(annotation => annotation.public);

  publicAnnotations.forEach(item => {
    conditions.push({
      entity: item.id,
      operator: 'exists',
      features: getFeatures(finalFeatures, item.id),
    });
  });

  return {
    name: `ConstraintSet-${len}`,
    intent_reference: null,
    conditions,
  };
};
